import React from 'react';

import { Card, Paragraph } from '@zillow/constellation-10';

import type { Message } from '../../../shared/models/Types';
import { FULLSTORY_EXCLUDE } from '../../constants/analytics';
import { useLastMessageQuery } from '../../utils/queries';

type Props = {
  leaseId: string;
  hideLabel?: boolean;
  hideMessage?: boolean;
  hideNote?: boolean;
  hideTitle?: boolean;
  hasWhiteBackground?: boolean;
  passedInMessageObject?: Message;
};

LastMessage.defaultProps = {
  hideMessage: false,
  hideNote: false,
  hideTitle: false,
};

export function LastMessage({
  hideMessage,
  hideNote,
  hideTitle,
  leaseId,
  hasWhiteBackground,
  passedInMessageObject,
}: Props): JSX.Element {
  const { data: messageObject } = useLastMessageQuery(leaseId, !passedInMessageObject);

  function renderLastMessage(): JSX.Element {
    const { title, message, note } = passedInMessageObject ?? messageObject;

    return (
      <>
        {(title || message) && (
          <Card tone="soft" elevated={false} outlined={false} className={FULLSTORY_EXCLUDE}>
            {!hideTitle && title && (
              <Paragraph data-test="title" css={{ textStyle: 'body-sm', fontWeight: 'bold' }}>
                {title}
              </Paragraph>
            )}
            {!hideMessage && message && (
              <Paragraph data-test="message" css={{ textStyle: 'body-sm', color: 'text.subtle' }}>
                <em>”{message}”</em>
              </Paragraph>
            )}
          </Card>
        )}
        {!hideNote && note && (
          <Paragraph data-test="note" css={{ textStyle: 'body-xs', marginTop: 'xs', color: 'text.neutral' }}>
            {note}
          </Paragraph>
        )}
      </>
    );
  }

  if (
    (messageObject == null || (!messageObject.message && !messageObject.title && !messageObject.note)) &&
    passedInMessageObject == null
  ) {
    return null;
  }

  return hasWhiteBackground ? (
    <Card tone="neutral" elevated={false}>
      {renderLastMessage()}
    </Card>
  ) : (
    renderLastMessage()
  );
}

export default LastMessage;
